const countries = [
  { label: '🇦🇫 Afghanistan (+93)', value: '+93', code: 'AF' },
  { label: '🇦🇱 Albania (+355)', value: '+355', code: 'AL' },
  { label: '🇩🇿 Algeria (+213)', value: '+213', code: 'DZ' },
  { label: '🇦🇩 Andorra (+376)', value: '+376', code: 'AD' },
  { label: '🇦🇴 Angola (+244)', value: '+244', code: 'AO' },
  { label: '🇦🇷 Argentina (+54)', value: '+54', code: 'AR' },
  { label: '🇦🇲 Armenia (+374)', value: '+374', code: 'AM' },
  { label: '🇦🇺 Australia (+61)', value: '+61', code: 'AU' },
  { label: '🇦🇹 Austria (+43)', value: '+43', code: 'AT' },
  { label: '🇦🇿 Azerbaijan (+994)', value: '+994', code: 'AZ' },
  { label: '🇧🇭 Bahrain (+973)', value: '+973', code: 'BH' },
  { label: '🇧🇩 Bangladesh (+880)', value: '+880', code: 'BD' },
  { label: '🇧🇾 Belarus (+375)', value: '+375', code: 'BY' },
  { label: '🇧🇪 Belgium (+32)', value: '+32', code: 'BE' },
  { label: '🇧🇷 Brazil (+55)', value: '+55', code: 'BR' },
  { label: '🇨🇦 Canada (+1)', value: '+1', code: 'CA' },
  { label: '🇨🇳 China (+86)', value: '+86', code: 'CN' },
  { label: '🇨🇴 Colombia (+57)', value: '+57', code: 'CO' },
  { label: '🇩🇰 Denmark (+45)', value: '+45', code: 'DK' },
  { label: '🇪🇬 Egypt (+20)', value: '+20', code: 'EG' },
  { label: '🇫🇷 France (+33)', value: '+33', code: 'FR' },
  { label: '🇩🇪 Germany (+49)', value: '+49', code: 'DE' },
  { label: '🇬🇷 Greece (+30)', value: '+30', code: 'GR' },
  { label: '🇭🇰 Hong Kong (+852)', value: '+852', code: 'HK' },
  { label: '🇮🇳 India (+91)', value: '+91', code: 'IN' },
  { label: '🇮🇩 Indonesia (+62)', value: '+62', code: 'ID' },
  { label: '🇮🇷 Iran (+98)', value: '+98', code: 'IR' },
  { label: '🇮🇶 Iraq (+964)', value: '+964', code: 'IQ' },
  { label: '🇮🇪 Ireland (+353)', value: '+353', code: 'IE' },
  { label: '🇮🇹 Italy (+39)', value: '+39', code: 'IT' },
  { label: '🇯🇵 Japan (+81)', value: '+81', code: 'JP' },
  { label: '🇰🇪 Kenya (+254)', value: '+254', code: 'KE' },
  { label: '🇲🇾 Malaysia (+60)', value: '+60', code: 'MY' },
  { label: '🇲🇽 Mexico (+52)', value: '+52', code: 'MX' },
  { label: '🇳🇵 Nepal (+977)', value: '+977', code: 'NP' },
  { label: '🇳🇱 Netherlands (+31)', value: '+31', code: 'NL' },
  { label: '🇳🇿 New Zealand (+64)', value: '+64', code: 'NZ' },
  { label: '🇳🇬 Nigeria (+234)', value: '+234', code: 'NG' },
  { label: '🇳🇴 Norway (+47)', value: '+47', code: 'NO' },
  { label: '🇵🇰 Pakistan (+92)', value: '+92', code: 'PK' },
  { label: '🇵🇭 Philippines (+63)', value: '+63', code: 'PH' },
  { label: '🇵🇱 Poland (+48)', value: '+48', code: 'PL' },
  { label: '🇵🇹 Portugal (+351)', value: '+351', code: 'PT' },
  { label: '🇶🇦 Qatar (+974)', value: '+974', code: 'QA' },
  { label: '🇷🇺 Russia (+7)', value: '+7', code: 'RU' },
  { label: '🇸🇦 Saudi Arabia (+966)', value: '+966', code: 'SA' },
  { label: '🇿🇦 South Africa (+27)', value: '+27', code: 'ZA' },
  { label: '🇰🇷 South Korea (+82)', value: '+82', code: 'KR' },
  { label: '🇪🇸 Spain (+34)', value: '+34', code: 'ES' },
  { label: '🇱🇰 Sri Lanka (+94)', value: '+94', code: 'LK' },
  { label: '🇸🇪 Sweden (+46)', value: '+46', code: 'SE' },
  { label: '🇨🇭 Switzerland (+41)', value: '+41', code: 'CH' },
  { label: '🇹🇭 Thailand (+66)', value: '+66', code: 'TH' },
  { label: '🇹🇷 Turkey (+90)', value: '+90', code: 'TR' },
  { label: '🇦🇪 United Arab Emirates (+971)', value: '+971', code: 'AE' },
  { label: '🇬🇧 United Kingdom (+44)', value: '+44', code: 'GB' },
  { label: '🇺🇸 United States (+1)', value: '+1', code: 'US' },
  { label: '🇻🇳 Vietnam (+84)', value: '+84', code: 'VN' },
]

export default countries
